<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="2"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding: 0.2em 3em">
        <!-- 左侧菜单栏 -->
        <div class="box">
          <div class="specialistContent_left">
            <div class="specialistContent_left_title">产品与服务</div>
            <div
              class="bG"
              v-for="(item, index) in leftMenu1"
              :key="index"
              :class="{ active: toggle == item.name }"
              @click="changeDetail(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="specialistContent_right">
            <div class="specialistContent_right_title">
              <div class="title">{{ toggle }}</div>
            </div>
            <div class="rightContent">
              <ul class="listBox" v-if="list.length > 0">
                <li
                  v-for="item in list"
                  :key="item.id"
                  @click="goToDetail(item.id)"
                >
                  <img
                    :src="$store.getters.imgUrl + item.logo"
                    alt
                    v-if="item.logo"
                  />
                  <!-- <img src="@/assets/image/equipment/3.png" alt="" v-else> -->
                  <div class="NoLogoBox" v-else>
                    <span>{{ item.name }}</span>
                  </div>
                  <span class="company">{{ item.enterpriseName }}</span>
                  <span class="titleInfo">{{ item.name }}</span>
                  <!-- <span class="info">{{item.content}}</span> -->
                  <div class="buttonZX">详情</div>
                </li>
                <li
                  v-show="list.length % 4 > 0"
                  v-for="item in 4 - (list.length % 4)"
                  :key="item"
                  class="addLi"
                ></li>
              </ul>
              <span v-if="list.length == 0">暂无数据</span>
              <Pagination
                :name="name"
                :total="total * 1"
                :replace="replace"
                @change="changePagination"
                v-show="list.length > 0"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
import Pagination from "@/components/pagination";
export default {
  name: "case",
  components: {
    footCode,
    headTop,
    Pagination,
  },
  data() {
    return {
      replace: false,
      leftMenu1: [],
      toggle: "环境政策咨询科",
      list: [],
      total: "",
      name: "产品与服务",
      mode: {
        page: 1,
        limit: 12,
        officeId: "",
      },
      scrollTop:"",
    };
  },
   activated() {
     this.$nextTick(() => {
      //恢复滚动高度
      console.log(this.$store.state.scrollTop);
      document
        .getElementsByClassName("specialistContent")[0]
        .scrollTo(0, this.$store.state.scrollTop);
    });
        
  },
 
    beforeRouteLeave(to, from, next) {
      this.scrollTop =document.getElementsByClassName("specialistContent")[0].scrollTop;
      this.$store.commit("changeScrollTop", this.scrollTop);
      console.log(this.scrollTop,"leave page");
      next();
    },
  mounted() {
    //   this.toggle = this.$route.query.name
    this.getLeftList();
  },
  methods: {
    changePagination(current) {
      // 第几页
      this.replace = false;
      this.mode.page = current;
      this.getDetail();
    },
    getLeftList() {
      this.ajaxUtil({
        method: "get",
        // url: '/apiAjax/api/home/index',
        url: this.$store.state.axiosUrl + "/api/home/getAllOffice",
      }).then((res) => {
        let a = res.data.filter((item) => {
          return item.type == 1;
        });
        let b = res.data
          .filter((item) => {
            return item.type == 2;
          })
          .splice(0, 2);
        this.leftMenu1 = [...a, ...b];
        this.mode.officeId = res.data[0].id;
        this.getDetail();
      });
    },
    getDetail() {
      // let params = {...this.mode,officeId:this.officeId }
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + `/api/home/v2/product/page`,
        params: this.mode,
      }).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    changeDetail(item) {
      this.toggle = item.name;
      this.mode.officeId = item.id;
      this.replace = true;
      this.mode.page = 1;
      this.getDetail();
    },
    goToDetail(id) {
      this.$router.push({
        path: "/case/caseDetail",
        query: {
          id: id,
          index: 2,
        },
      });
    },
    goToConsultation(pid) {
      if (!pid) pid = 0;
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$message.error("请先登录");
        return false;
      } else {
        this.$store.commit("changechatShow", true);
        this.$store.commit("changePid", pid);
      }
    },
  },
};
</script>
<style scoped lang="less">
// @import url('~@/assets/css/index.less');
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  min-height: 110vh;
  // overflow: auto;
  // padding: 0.2em 3em;
  .specialistContent_left {
    font-size: 0.17em;
    color: #333;
    div {
      padding: 0.2em 1em;
      height: 2.5em;
      text-align: center;
      background-color: #d6f0f6;
      margin-top: 0.08em;
      cursor: pointer;
      font-size: 0.85em;
      width: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .specialistContent_left_title {
      background: radial-gradient(circle, #3cc9e4 0%, #2579bf 100%);
      color: #fff;
      padding: 0.6em;
      //   width: 15em;
      font-size: 1em;
    }
    .bG:hover{
      color: #2579bf;
      background-color: #fff;
    }
    .active {
      color: #2579bf;
      background-color: #fff;
      border-left: 0.5em solid #2579bf;
    }
  }
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
      .title {
        color: #2579bf;
        font-size: 16px;
        padding-bottom: 5px;
        border-bottom: 4px solid #2579bf;
      }
    }
    //   列表
    .listBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        border: 1px solid #eee;
        display: flex;
        flex-direction: column;
        position: relative;
        width: 22%;
        // height: 12.5em;
        padding-bottom: 0em;
        margin-top: 20px;
        cursor: pointer;
        .titleInfo {
          width: 100%;
          height: 54px;
          line-height: 23px;
          color: #2579bf;
          font-size: 0.84em !important;
          font-weight: 600;
          padding: 5px 10px 5px 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        img {
          height: 122px;
          width: 100%;
        }
        .company {
          position: absolute;
          padding: 5px;
          top: 95px;
          left: 0;
          width: 100%;
          font-size: 0.8em;
          white-space: nowrap;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
        .info {
          padding: 8px 10px;
          padding-bottom: 80px;
          overflow: hidden;
          font-size: 0.15em;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          color: #555;
        }
      }
    }
  }
}
.footer {
  width: 100%;
  margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  height: 100%;
  display: flex;
}
.addLi {
  border: none !important;
}
.NoLogoBox {
  background-image: url("~@/assets/image/equipment/3.png");
  height: 122px;
  width: 100%;
  display: flex;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: hzgb;
  align-items: center;
  text-align: -webkit-center;
  span {
    font-size: 13px !important;
    font-weight: 600;
    letter-spacing: 3px;
  }
}
.buttonZX {
  text-align: center;
  padding: 7px;
  background: linear-gradient(-90deg, #25ccbd 0%, #30a8da 100%);
  color: #fff;
  margin-top: 10px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // width: 100%;
}
.rightContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/case/index.vue